import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import EmailPromptModal from '../../../common/EmailPromptModal';
import UploadButton from './UploadButton';

const ImportSubscriptionsForm = ({ onChange, onSubmit, emailIsOn, defaultEmail }) => (
  <div className="c-memberships-container u-full-width">
    <form>
      <div className="c-memberships-container__text c-memberships-container__title u-text-left">
        {t('memberships:import_subscriptions.title')}
      </div>
      <div className="c-memberships-container__text u-text-left">
        <p className="u-mb+">{t('memberships:import_subscriptions.description')}</p>

        {t('memberships:import_subscriptions.csv_header_requirements')}
        <ul>
          <li>{t('memberships:import_subscriptions.email_address')}</li>
          <li>{t('memberships:import_subscriptions.membership_package_name')}</li>
        </ul>
      </div>
      <div className="u-mt+">
        <UploadButton onChange={onChange}>{t('memberships:import_subscriptions.upload_button')}</UploadButton>
      </div>
    </form>

    <EmailPromptModal
      display-if={emailIsOn}
      onSubmit={onSubmit}
      title={t('memberships:import_subscriptions.email_modal_title')}
      defaultEmail={defaultEmail}
    />
  </div>
);

ImportSubscriptionsForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  emailIsOn: PropTypes.bool,
  defaultEmail: PropTypes.string,
};

ImportSubscriptionsForm.defaultProps = {
  emailIsOn: false,
  defaultEmail: '',
};

export default ImportSubscriptionsForm;
